import { zodResolver } from "@hookform/resolvers/zod";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { t } from "i18next";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import useSellerId from "../../../hooks/useSellerId";
import { useGetSellers } from "../../../services/usersApi";
import BasicDialog from "../../base/BasicDialog";
import SelectCreateTaskOrContactDialog from "./SelectCreateTaskOrContactDialog";

export const clientPassportFormSchema = z.object({
    sellerId: z.string().optional(),
});

export function ClientConfirmDiscoveryDialog(props) {
    const currentSellerId = useSellerId();
    const { handleSubmit, control, formState, register, reset, watch } = useForm({
        resolver: zodResolver(clientPassportFormSchema),
        defaultValues: { sellerId: currentSellerId },
    });
    const {
        openDialog: openSelectCreateTaskOrContactDialog,
        closeDialog: closeSelectCreateTaskOrContactDialog,
    } = useDialogBetter();

    const customerId = props.newCustomerId ?? props.customerId;
    const personId = props.newPersonId ?? props.personId;

    const { data: sellers } = useGetSellers();

    const onSubmit = (data) => {
        if (props.onConfirm) {
            props.onConfirm(data);
        }

        openSelectCreateTaskOrContactDialog({
            Component: SelectCreateTaskOrContactDialog,
            componentProps: {
                customerId: customerId,
                personId: personId,
                sellerId: watch("sellerId"),
                onClose: closeSelectCreateTaskOrContactDialog,
            },
        });
    };

    return (
        // @ts-ignore
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={props.title}
            maxWidth={"sm"}
            showTopCloseButton={true}
            showTopFullScreenButton={false}
            titleSx={{
                pb: 0,
            }}
            headerComponent={
                <Typography
                    variant={"subtitle1"}
                    sx={{ color: "text.secondary", mx: "auto", mb: 1 }}
                >
                    {t("clients.discovery.selectCaretakerOrGoBack")}
                </Typography>
            }
        >
            <Grid container direction={"column"}>
                <Grid item>
                    <Controller
                        control={control}
                        name="sellerId"
                        render={({ field }) => (
                            <Grid item xs={12}>
                                <TextField
                                    {...field}
                                    select
                                    label={t("table.contacts.seller")}
                                    size="small"
                                    fullWidth
                                >
                                    {sellers?.map((seller) => (
                                        <MenuItem key={seller.id} value={seller.id}>
                                            {seller.full_name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid container spacing={2} justifyContent={"center"} sx={{ mt: 3 }}>
                    <Grid item xs={6}>
                        <Button
                            onClick={handleSubmit(onSubmit)}
                            fullWidth
                            startIcon={<CheckCircleIcon />}
                            variant={"contained"}
                            color={"success"}
                        >
                            {t("confirm")}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </BasicDialog>
    );
}
